import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    calcTextAreaHeight,
    formatDate, generateUUID2,
    getFileIcon,
    getImagePath, getImagePathSvg,
    getImagePathWithTheme, getJournalName,
    getLocalFilePath,
    imgPathPerfix, isAudioAnnoElement, isCardAnnoElement, isDarkMode, isInDraw, isInSidebar, isPdfAnnoElement,
    isVideoAnnoElement
} from "@/utils";
import {getDrawPath, getImageNameFromdeepLinkType} from "@/Utility";
import {EditorContent, useEditor} from "@tiptap/react";
import {getCardById, getCardDoc, updateCard} from "@model/card";
import {KEYS} from "../../../../@excalidraw/packages/excalidraw/keys";
import {
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_TEST_ONDRAG_NOTE,
    EVENT_UPDATE_HIGHLIGHT_ANNO, KEY_ISCTRL_CMD_PRESSED,
    usedColorToShowColor
} from "@/Const";
import {getNoteById} from "@model/note";
import { t } from "i18next";
import {getCardTitle0} from "@/Utility0";
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import {debugLog} from "@/LogUtils";
import {postMessage} from "@/common/event";
import { message } from "antd";
import global from "@/global";

const GlobalSearchItem = forwardRef((props:{arrayDatas:any,searchKey:any,isSearching:any},ref)=>{
    useImperativeHandle(ref,()=>({
        resetPreview:resetPreview
    }))
    const [selectData,setSelectData] = useState<any>(null);
    const divListContainerRef = useRef(null);

    const [arrayDatas,setArrayDatas] = useState(props.arrayDatas);
    const mIsUsedKey = useRef<any>(false);
    const divItemContainerRef = useRef(null);

    function onKeydown(event:any){
        // debugLog('keydown',event);

        if (event.key == KEYS.ESCAPE){
            window.closeDialogGlobalSearch();
            return;
        }
        mIsUsedKey.current = true;
        if (event.code == KEYS.ARROW_DOWN){
            var nIndex = arrayDatas.findIndex(p=>p.isHover);
            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>{
                p.isHover = false;
            })
            if (nIndex >= arrayDatas.length-1){
                nIndex = 0;
            }else{
                nIndex++;
            }
            arrayNew[nIndex].isHover = true;
            setArrayDatas(arrayNew);

            //显示这个的预览
            showPreview(arrayNew[nIndex]).then(res=>{
                scrollToIndex(nIndex);
            });
            event.preventDefault();
            event.stopPropagation();
        }else if (event.code == KEYS.ARROW_UP){
            var nIndex = arrayDatas.findIndex(p=>p.isHover);
            var arrayNew = [...arrayDatas];
            arrayNew.forEach(p=>{
                p.isHover = false;
            })
            if (nIndex == 0){
                nIndex = arrayDatas.length -1;
            }else{
                nIndex--;
            }
            arrayNew[nIndex].isHover = true;
            setArrayDatas(arrayNew);

            //显示这个的预览
            showPreview(arrayNew[nIndex]).then(res=>{
                scrollToIndex(nIndex);
            });
            event.preventDefault();
            event.stopPropagation();
        }else if (event.code == KEYS.ENTER){
            //选择这个...
            const nIndex = arrayDatas.findIndex(p=>p.isHover);
            openItem(arrayDatas[nIndex]);
            event.preventDefault();
            event.stopPropagation();
        }
    }


    useEffect(()=>{
        document.body.addEventListener('keydown',onKeydown);

        return ()=>{
            document.body.removeEventListener('keydown',onKeydown)
        }
    })

    useEffect(() => {
        const arrayTmp = [...props.arrayDatas];
        arrayTmp.forEach(p=>{
            p.isHover = false;
        })
        if (arrayTmp.length >0){
            arrayTmp[0].isHover = true;
            setSelectData(arrayTmp[0]);
            showPreview(arrayTmp[0]);
        }
        setArrayDatas(arrayTmp);
    }, [props.arrayDatas]);

    let editor = useEditor({
        autofocus:false,
        injectCSS: true,
        editable:false,
        extensions: getTiptapExtension(),
        editorProps: {
            attributes: {
                // class: '',
            },
        },
        onCreate(options){
            const nIndex = props.arrayDatas.findIndex(p=>p.isHover);
            if (nIndex >= 0){
                const item = (props.arrayDatas[nIndex]);
                if (item.type == 'card' || item.type == 'journal'){
                    showPreview(item);
                }
            }
            updateEditDefaultSize();
            options.editor.commands.setFontSize('12px');

        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    /**
     * 滚动到索引
     * @param nIndex
     */
    const scrollToIndex = (nIndex:number)=>{
        if (divListContainerRef.current){
            if (nIndex > 3){
                divListContainerRef.current?.scrollTo(0,(nIndex-3)*36 + 16)
            }else{
                divListContainerRef.current?.scrollTo(0,0)
            }
        }
    }

    //显示预览
    async function showPreview(item:any){
        updateEditDefaultSize();
        setSelectData(item);
        if (item.type == 'card' || item.type == 'journal'){
            if (!item.doc){
                item.doc = await getCardDoc(item.id);
            }
            editor?.commands.setContent(item.doc);
        }
    }

    /**
     * 重置预览
     */
    const resetPreview = ()=>{
        setSelectData(null);
        editor?.commands.setContent('');
    }

    /**
     * 打开选择的条目
     */
    const openItem = (item:any)=>{
        window.closeDialogGlobalSearch();
        if (item.type == 'project'){
            // getNoteById(item.id).then(projectInfo=>{
            //     // window.closeDialogGlobalSearch();
            //
            // })
            const linkInfo:any = {id:item.id};
            if (item.parentBoards?.length > 0){
                linkInfo.id = item.id;
                linkInfo.pageId = item.pageId;
            }
            window.navigate(getDrawPath(),{searchKey:props.searchKey,time:Date.now(),linkInfo:linkInfo})//这个time 是为了搜索。。。。。在同一个项目中点了全局搜索来处理的...
        }else{
            window.showLibraryFilePreview(item);
            if (props.searchKey){
                if (item.type == 'card' || item.type == 'journal'){
                    setTimeout(()=>{
                        window.GSearchOpen(props.searchKey,true);
                    },600)
                }
            }
        }
    }

    const updateEditDefaultSize = ()=>{
        setTimeout(()=>{
            const div = document.getElementById('editor-small-preview');
            if (div){
                const editDiv = div.childNodes[0];
                editDiv?.classList.remove('ProseMirror');
                editDiv.classList.add('ProseMirror-card-small')
            }
        },100)
    }

    const getTitle = (p)=>{
        if (p.type == 'journal'){
            return getJournalName(p.journalTime);
        }
        if (p.type == 'card'){
            return getCardTitle0(p);
        }
        if (p.type == 'project'){
            let szTitle = '';

            szTitle = p.boardName || p.name;

            return szTitle;
        }
        return p.name || t('Untitled');
    }

    const getProjectPreviewFolderTree = (p)=>{
        let szTitle = '';
        if (p.parentBoards){
            szTitle = p.parentBoards.map(p=>{
                return p.title + ' > '
            })
        }
        return szTitle;
    }

    const hasProjectThumb = ()=>{
        return selectData?.thumbUrl?.startsWith('localfile://')
    }

    return<div style={{display:"grid",gridTemplateColumns:'1fr 366px',height:'100%'}}>
        <div ref={divListContainerRef} style={{borderRight:'1px solid var(--line-color)',paddingTop:'6px',overflowY:'auto'}}>
            {
                arrayDatas.map(p=>{
                    return<div className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3 default-font-size'}
                               onMouseEnter={(event)=>{
                        if (mIsUsedKey.current)return;
                        var arrayNew = [...props.arrayDatas];
                        arrayNew.forEach(p => p.isHover = false);
                        p.isHover = true;
                        setSelectData(p);
                        showPreview(p);
                    }} onClick={(event)=>{
                        if (event?.metaKey || event?.ctrlKey) {
                            global.g_isCtrlPressed = true;
                            setTimeout(() => {
                                global.g_isCtrlPressed = false;
                            }, 2000);
                        }
                        openItem(p);
                    }} onMouseMove={()=>{
                        mIsUsedKey.current = false;
                    }} style={{padding:'6px 6px',background: p.isHover ? 'var(--popup-cardlist-background-color)' : 'transparent',}}>
                        <img className={'img-16'} style={{flexShrink:'0'}} src={getImagePathWithTheme(getImageNameFromdeepLinkType(p.type))}/>
                        <span className={'ml-10 span-single-line'}>{getTitle(p)}</span>
                        {
                            isInDraw() && p.isHover &&
                            <div className={'flex-row-vertical-center cursor-pointer'} onClick={(e)=>{
                                e.stopPropagation();
                                message.info(t('AddedToCurrentBoard'))
                                //当前到当前画板...
                                postMessage(EVENT_TEST_ONDRAG_NOTE,{...p})
                            }}
                                 style={{marginLeft: 'auto', flexShrink: '0'}}>
                                <img className={'img-14'} src={getImagePathSvg('add_blue')}/>
                                <span className={'ml-2'}
                                      style={{color: 'var(--primary-color)'}}>{t('AddToCurrentBoard')}</span>
                            </div>
                        }

                    </div>
                })
            }

            {
                arrayDatas.length == 0 && props.searchKey && !props.isSearching &&
                <div className={'flex-center'} style={{width: '100%', height: '100%'}}>
                    <span className={'mt-6'} style={{color: 'var(--color-alpha-b3)'}}>{t("LibraryIsEmptyTips")}</span>
                </div>

            }
        </div>
        <div ref={divItemContainerRef} style={{overflowX: 'hidden', overflowY:'auto',padding:'16px',marginRight:'-22px',position:'relative',}}>
            {
                // (selectData?.type == 'card' || selectData?.type == 'journal') &&
                <div style={{
                    display:(selectData?.type == 'card' || selectData?.type == 'journal')?'inherit':'none'
                }}>
                    {
                        selectData?.name &&
                        <span className={'font-family-semi-bold'}
                          style={{color: isDarkMode()?'#EFEFEF':'#4C4C4C',fontSize:'20px',fontWeight:'500'}}>{selectData?.name}</span>
                    }
                    <EditorContent id={'editor-small-preview'}
                                   className={''}
                                   style={{padding: '0px', fontSize: '12px',marginTop:'12px'}}
                                   editor={editor}/>
                </div>
            }

            {
                (selectData?.type == 'pdf' || selectData?.type == 'video' || selectData?.type == 'liveVideo' || selectData?.type == 'bilibili' || selectData?.type == 'youtube' || selectData?.type == 'baidu') &&
                <div className={'flex-center'} style={{width:'100%',height:'100%'}}>
                    <img style={{objectFit:'cover',width:'100%',height:'auto'}} src={selectData.thumbImage}/>
                </div>
            }

            {
                (selectData?.type == 'image') &&
                <div className={'flex-center'} style={{width:'100%',height:'100%'}}>
                    <img style={{objectFit:'cover',width:'100%',height:'auto'}} src={getLocalFilePath(selectData.fileName,selectData.isAbsolutePath)}/>
                </div>
            }

            {
                (selectData?.type == 'file' || selectData?.type == 'audio') &&
                <div className={'flex-column-center'} style={{width: '100%', height: '100%'}}>
                    <img style={{objectFit: 'cover', width: '90px', height: '90px'}} src={imgPathPerfix() + (getFileIcon(selectData.fileName))}/>
                    <span className={'mt-6'}>{selectData?.name}</span>
                </div>
            }

            {
                (selectData?.type == 'project') &&
                <div className={hasProjectThumb()?'flex-col':'flex-column-center'} style={{width: '100%', height: '100%'}}>
                    {
                        hasProjectThumb() &&
                        <img style={{marginBottom:'16px',left:'0',top:'0', height:`${divItemContainerRef.current?.offsetHeight*0.5}px`}} src={selectData.thumbUrl}/>
                        //显示缩略图
                    }
                    <div className={'flex-column-center'}>
                        <img style={{width: '16px', height: '16px'}}
                             src={getImagePathWithTheme('deeplink_project')}/>
                        {
                            selectData?.parentBoards?.length > 0 ?
                                <>
                                    <span className={'mt-10'} style={{
                                        color: 'var(--text-color-bab8b8)',
                                        textAlign: 'center'
                                    }}>{getProjectPreviewFolderTree(selectData)}</span>
                                    <span className={'mt-6'}>{selectData?.boardName}</span>
                                </> :
                                <span className={'mt-6'}>{selectData?.name || t("Untitled")}</span>
                        }

                    </div>

                </div>
            }

            {
                selectData?.type == 'webLink' &&
                <div className={'flex-column-center'} style={{width: '100%', height: '100%'}}>
                    {/*<img style={{objectFit: 'cover', width: '16px', height: '16px'}}*/}
                    {/*     src={getImagePathWithTheme('deeplink_project')}/>*/}
                    <span className={'mt-6'}  style={{color:'var(--color-alpha-b3)'}}>{t("No thumbnail")}</span>
                </div>
            }

            {
                (selectData?.type == 'videoAnno' || selectData?.type == 'audioAnno') &&
                <div style={{
                    overflow: 'auto',
                    color: 'var(--text-color)',
                    width: '100%',
                    marginTop: '-8px',
                    height: '100%',
                    position: 'relative',
                    // background:'var(--canvas-iframe-item-background)'
                }}>
                    <div className={'flex-row-vertical-center mt-4'}>
                        <img className={'img-16'} src={getImagePath('video_anno_draw')}/>
                        <span className={'span-single-line ml-10'} style={{
                            flexGrow: '1',
                            textAlign: 'left',
                            color: '#FF9500'
                        }}>{selectData.name}</span>
                        <span style={{
                            flexShrink: '0',
                            marginLeft: '6px'
                        }}>{formatDate(new Date(selectData.time), 'hh:mm:ss')}</span>
                        {
                            selectData.endTime > 0 &&
                            <span style={{
                                flexShrink: '0',
                                marginLeft: '0px'
                            }}>-{formatDate(new Date(selectData.endTime), 'hh:mm:ss')}</span>
                        }
                        {
                            selectData.loop &&
                            <img className={'img-12 ml-4'} src={getImagePathWithTheme('video_loop')}/>
                        }
                    </div>
                    <div id={`video-anno-${selectData.id}`}
                         style={{textAlign: 'left', marginTop: '10px', overflow: 'hidden'}}>
                        {
                            selectData.title &&
                            <span className={'font-family-semi-bold'} style={{
                                fontSize: '16px',
                                textWrap: 'wrap'
                            }}>{selectData.title}</span>
                        }
                        <div style={{marginTop: '6px'}}>
                                <span style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    whiteSpace: 'pre',
                                    textWrap: 'wrap',
                                    wordBreak: 'break-word'
                                }}>{selectData.content}</span>
                            {
                                selectData.thumbImage &&
                                <img style={{width: '100%', height: 'auto', marginTop: '8px', borderRadius: '8px'}}
                                     src={getLocalFilePath(selectData.thumbImage, false)}/>
                            }
                        </div>
                    </div>
                </div>
            }

            {
                (selectData?.type == 'pdfAnno' || selectData?.type == 'cardAnno') &&
                <div style={{
                    width: '100%',
                    // background: 'var(--canvas-iframe-item-background)'
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontSize: '12px',
                            paddingLeft: '6px',
                            paddingRight: '6px',
                            paddingBottom: '6px',
                            height: '100%',
                            overflow: 'hidden',
                        }}>
                        <div className={'header-part'}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexShrink: '0',
                                    minHeight: '20px'
                                }}><span
                                style={{
                                    color: usedColorToShowColor(selectData.color),
                                    border: `1px solid ${usedColorToShowColor(selectData.color)}`,
                                    width: '18px',
                                    height: '18px',
                                    display: 'flex',
                                    justifyItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: '0',
                                    minHeight: '18px',
                                }}>A</span><span
                                style={{
                                    marginLeft: '4px',
                                    color: usedColorToShowColor(selectData.color),
                                    textOverflow: 'ellipsis',//这几个东西，当缩放的时候，宽度小到一定程度 span不会自动变小。就不再变化了。。。。。
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden'
                                }}>{"" + selectData.name}</span>
                            </div>
                            <div
                                style={{
                                    height: '1px',
                                    background: 'var(--line-color)',
                                    marginTop: '6px',
                                    marginLeft: '-16px',
                                    marginRight: '-16px'
                                }}></div>
                            {
                                (selectData.text) &&
                                <blockquote
                                    style={{
                                        marginTop: '10px',
                                        marginLeft: '0px',
                                        marginRight: '0px',
                                        paddingLeft: '8px',
                                        borderLeft: `2px solid ${usedColorToShowColor(selectData.color)}`,
                                        textAlign: 'left'
                                    }}>
                                  <span style={{
                                      color: isDarkMode() ? 'var(--text-color)' : 'var(--text-color)',
                                      marginTop: '4px'
                                  }}>{selectData.text}</span>
                                </blockquote>
                            }
                            {
                                !selectData.text &&
                                <div className={'flex-center'}>
                                    <img style={{
                                        maxWidth: '100%',
                                        marginTop: '12px',
                                        height: 'auto',
                                        display: 'block',
                                        maxHeight: '200px'
                                    }}
                                         src={selectData.image || selectData.thumbImage}/>
                                </div>
                            }
                        </div>

                        <span className={'font-family-regular'}
                                  style={{
                                      margin: '8px 0', resize: 'none',
                                      fontSize: '12px',
                                      // flexGrow: '1',
                                      // flexShrink: '0',
                                      marginBottom: '1px',
                                      minHeight: '20px',
                                      color: 'var(--text-color)',
                                      background: '#ff000000',
                                      fontFamily: 'Popins',
                                      border: 'none', padding: '0', overflow: 'hidden',
                                      pointerEvents: 'all', textWrap: 'wrap'
                                  }}>{selectData.comment}</span>
                    </div>
                </div>
            }

        </div>
    </div>
})

export default GlobalSearchItem;






























